function timeSince(date: any): string {
  const currentDate: any = new Date();
  let seconds = Math.floor((currentDate - date) / 1000);

  let interval = seconds / 31_536_000;

  if (interval > 1) {
    return `${Math.floor(interval)} year${interval >= 2 ? "s" : ""} ago`;
  }

  interval = seconds / 2_592_000;
  if (interval > 1) {
    return `${Math.floor(interval)} month${interval >= 2 ? "s" : ""} ago`;
  }

  interval = seconds / 86_400;
  if (interval > 1) {
    return `${Math.floor(interval)} day${interval >= 2 ? "s" : ""} ago`;
  }

  interval = seconds / 3_600;
  if (interval > 1) {
    return `${Math.floor(interval)} hour${interval >= 2 ? "s" : ""} ago`;
  }

  interval = seconds / 60;
  if (interval > 1) {
    return `${Math.floor(interval)} minute${interval >= 2 ? "s" : ""} ago`;
  }
  return `${Math.floor(interval)} minute${interval >= 2 ? "s" : ""} ago`;
}
export default timeSince;
